import { Helmet } from 'react-helmet';
import {
  Box,
  Card,
  CardContent,
  Alert,
  Container,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import moment from 'moment';
import { checkAutoLogin } from 'src/actions/getTokenActions';
import { useCallback } from 'react';
import ListToolbar from 'src/components/ListToolbar';

const DevicesSearchList = () => {
  const [data, setdata] = useState([]);
  const [httpError, setHttpError] = useState(false);
  const [searchFailed, setClass] = useState(false);

  const isLogin = useSelector(state => state.gettocken.islogin);
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [progress, setprogress] = useState(false);
  const [isSearchDisabled, setDisableFilter] = useState(false);
  const [query, setQuery] = useState('');

  useEffect(() => {
    const apiurl = sessionStorage.getItem('apiurl')
    console.log("Apiurl", apiurl)
    let token = checkAutoLogin(dispatch)
    if (!token && isLogin === false) {
      navigate('/login', { replace: true });
    } else {
        setprogress(true)
        setDisableFilter(true)
        setHttpError(false)
        axios.get(`https://${apiurl}/api/Device/GetByName/${query}`, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token,
          }
        }).then(res => {
          console.log('ISOS: ', res.data)
          setdata(res.data)
          setprogress(false)
          setDisableFilter(false)
        }).catch(function (error) {
          setHttpError(true)
          setprogress(false)
          setDisableFilter(false)
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            setdata([])
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
          }
          console.log(error.config);
        }
        )
    }
  }, [isLogin, query])
 
  const searchDevices = useCallback((isoName) => {
    setQuery(isoName)
  }, [])

  return (
    <>
      <Helmet>
        <title>Devices</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false} >
        <ListToolbar searchItem={searchDevices} isSearchDisabled={isSearchDisabled} searchFailed={searchFailed} placeHolder="Suche" />
          {progress &&
            <LinearProgress />
          }
          {!progress &&
            <Box sx={{ pt: 3 }}>
              <Card >
                <CardContent>
                  <Box sx={{ minWidth: 1020 }}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            ID                      
                          </TableCell>
                          <TableCell>
                            Name
                          </TableCell>
                          <TableCell style={{ textAlign: 'center' }}>
                          Kunde  
                          </TableCell>
                          <TableCell>
                          Rechenzentrum
                          </TableCell>
                          <TableCell style={{ textAlign: 'center' }}>
                          Rack        
                          </TableCell>
                          <TableCell style={{ textAlign: 'center' }}>
                          Stromkreis                    
                          </TableCell>
                          <TableCell style={{ textAlign: 'center' }}>
                            Phase
                          </TableCell>
                          <TableCell style={{ textAlign: 'center' }}>
                            Letztes Datum
                          </TableCell>
                          <TableCell style={{ textAlign: 'center' }}>
                          Wert
                          </TableCell>                                            
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          !progress && data.length === 0 &&
                          <TableRow>
                            <TableCell colSpan="6">                      
                                {!httpError && <Alert severity="info">Für die Ausgewählten Einstellungen sind keine Daten verfügbar </Alert>} 
                                {httpError && query !== "" && <Alert severity="error">Es ist ein Fehler aufgetreten! Bitte versuchen Sie es noch mal. </Alert>}                                                    
                                {query === "" && <Alert severity="info">Bitte geben Sie den Gerätenamen ein. </Alert>}                                                    
                            </TableCell>
                          </TableRow>
                        }
                        {data.map((item, index) => {
                            return (
                                <>
                                 <TableRow
                                hover
                                key={index}
                              >
                                <TableCell>  
                                    {item.deviceId}                       
                                </TableCell>
                                <TableCell>
                                  {item.deviceName}
                                </TableCell>
                                <TableCell style={{ textAlign: 'center' }}>
                                  {item.accountName}
                                </TableCell>
                                <TableCell>
                                  {item.dataCenter}
                                </TableCell>
                                <TableCell style={{ textAlign: 'center' }}>
                                  {item.rackName}
                                </TableCell>
                                <TableCell style={{ textAlign: 'center' }}>
                                  {item.valuesByPhase[0].circuitName ?? ""}
                                </TableCell>
                                <TableCell style={{ textAlign: 'center' }}>
                                  {item.valuesByPhase[0].phaseName ?? ""}
                                </TableCell>
                                <TableCell style={{ textAlign: 'center' }}>
                                <span>{moment(item.valuesByPhase[0].date, "DD.MM.YYYY HH:mm:ss").format("DD.MM.YYYY HH:mm:ss") ?? ""}</span>                            
                                </TableCell>
                                <TableCell style={{ textAlign: 'center' }}>
                                {new Intl.NumberFormat("de-DE").format(item.valuesByPhase[0].value.toFixed(2)) ?? ""} kW                                   
                                </TableCell>                        
                              </TableRow>
                                
                                {item.valuesByPhase.length > 1 && item.valuesByPhase.slice(1).map((subItem, subIndex) => {
                                    return(
                                        <TableRow
                                hover
                                key={subIndex}
                              >
                                <TableCell>                    
                                </TableCell>
                                <TableCell>
                                </TableCell>
                                <TableCell style={{ textAlign: 'center' }}>
                                </TableCell>
                                <TableCell>
                                </TableCell>
                                <TableCell style={{ textAlign: 'center' }}>
                                </TableCell>
                                <TableCell style={{ textAlign: 'center' }}>
                                  {subItem.circuitName ?? ""}
                                </TableCell>
                                <TableCell style={{ textAlign: 'center' }}>
                                  {subItem.phaseName ?? ""}
                                </TableCell>
                                <TableCell style={{ textAlign: 'center' }}>
                                <span>{moment(subItem.date, "DD.MM.YYYY HH:mm:ss").format("DD.MM.YYYY HH:mm:ss") ?? ""}</span>                            
                                </TableCell>
                                <TableCell style={{ textAlign: 'center' }}>
                                {new Intl.NumberFormat("de-DE").format(subItem.value.toFixed(2)) ?? ""} kW                                   
                                </TableCell>                        
                              </TableRow>
                                    )
                                })}                          
                                </>                          
                            )
                        } )
                        }
                      </TableBody>
                    </Table>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          }
        </Container>
      </Box>

    </>
  );
};

export default DevicesSearchList;